import { render, staticRenderFns } from "./job-status.component.vue?vue&type=template&id=79872a24"
import script from "./job-status.component.ts?vue&type=script&lang=ts&external"
export * from "./job-status.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports